package com.macrofocus.nastac.ui.layer

import deckgl.BitmapLayer
import deckgl.BitmapLayerProps
import deckgl.TileLayer
import deckgl.TileLayerProps
import js.objects.unsafeJso

fun createNaturalEarthLayer() : TileLayer {
    val tileLayer = TileLayer(unsafeJso<TileLayerProps> {
        this.id = "natural-earth-raster-layer"
        this.data = "/natural_earth_shaded_relief/{z}/{x}/{y}" // Tile URL
//            asDynamic().getTileData = { x: Int, y: Int, z: Int ->
//                "/natural_earth_shaded_relief/$z/$x/$y"
//            }

        asDynamic().minZoom = 0 // From tilejson
        asDynamic().maxZoom = 6 // From tilejson
        asDynamic().tileSize = 256
        asDynamic().opacity = 0.1 // Set opacity
        asDynamic().tileOpacity = 0.1 // Set opacity
        asDynamic().renderSubLayers = { props: dynamic ->
            val bbox = props.tile.bbox
            val index = props.tile.bboindexx
            BitmapLayer( unsafeJso<BitmapLayerProps> {
                this.id = "natural-earth-raster-layer-bitmap-$index"
                this.data = null
                asDynamic().image = props.data
                asDynamic().bounds = arrayOf(bbox.west, bbox.south, bbox.east, bbox.north)
                asDynamic().opacity = 0.1 // Set opacity here for BitmapLayer
            }
            )
        }
    })
    return tileLayer
}